export class GetCreditsResponse {
    'totalRemainingCredits';
    'costUnit';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalRemainingCredits",
            "baseName": "totalRemainingCredits",
            "type": "number",
            "format": "double"
        },
        {
            "name": "costUnit",
            "baseName": "costUnit",
            "type": "CostUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetCreditsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
